// This file is auto-generated by the build metadata system. Do not edit manually.
export const buildInfo = {
  appName: "Community Docs",
  version: "2.10.14",
  gitCommitSha: "dd9a0ca" as string,
  gitBranch: "master" as string,
  buildTimestamp: "2026-08-27T02:45:18.377Z",
  environment: "production",
} as const;

export type BuildInfo = typeof buildInfo;
